module.exports = __webpack_public_path__ + "static/assets/eab86ee804b9e1520471937793c1fb73.png";